import { render, staticRenderFns } from "./FooterAgreement.vue?vue&type=template&id=5872304a&scoped=true&"
import script from "./FooterAgreement.vue?vue&type=script&lang=js&"
export * from "./FooterAgreement.vue?vue&type=script&lang=js&"
import style0 from "./FooterAgreement.vue?vue&type=style&index=0&id=5872304a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872304a",
  null
  
)

export default component.exports